import React from 'react'
;

const Counter = () => {

    

    return (
        <div className="counter-area bg-primary-deep" style={{ backgroundImage: 'url("/images/indicator_img.jpg")' }}>
            <div className="container">
                <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 counter1-box wow fadeInUp" data-wow-duration=".5s" data-wow-delay=".20s">
                        <h2 className="about-counter title-bar-counter" data-num={100}>100 </h2>
                        <p> + <br />
                            PROFESSIONAL TEACHER</p>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 counter1-box wow fadeInUp" data-wow-duration=".5s" data-wow-delay=".40s">
                        <h2 className="about-counter title-bar-counter" data-num={20}>20</h2>
                        <p>ONLINE COURSES</p>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 counter1-box wow fadeInUp" data-wow-duration=".5s" data-wow-delay=".60s">
                        <h2 className="about-counter title-bar-counter" data-num={100}>100</h2>
                        <p> + <br />TRAINING CENTER IN INDIA</p>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 counter1-box wow fadeInUp" data-wow-duration=".5s" data-wow-delay=".80s">
                        <h2 className="about-counter title-bar-counter" data-num={100}>100</h2>
                        <p>+ <br />NEW COURSES EVERY YEAR</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export  {Counter};